import './AppBadge.css';
import React from 'react'
import { Tag, Tooltip } from 'antd';
import classNames from 'classnames';

type Props = {
  children?: React.ReactNode;
  className?: string;
  solid?: boolean
  color?: string;
  tooltip?: string;
  inverse?: boolean;
}

export default function AppBadge({ children, className, solid, inverse, color = "#777", tooltip }: Props) {
  return (
    <Tooltip title={tooltip}>
      <Tag className={classNames("app-badge", className, { solid, inverse })} style={{ "--category-color": color } as React.CSSProperties}>
        {children}
      </Tag>
    </Tooltip>
  )
}